module.exports = __webpack_public_path__ + "static/img/regist_bac.a9d225e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/regist_bac.png
// module id = Xcpp
// module chunks = 15